import {Component, Input, OnInit} from '@angular/core';
import {AbstractQuoteComponent} from '../abstract-quote-component';

@Component({
  selector: 'app-service-quote',
  templateUrl: './service-quote.component.html',
  styleUrls: ['./service-quote.component.css']
})
export class ServiceQuoteComponent extends AbstractQuoteComponent implements OnInit {

  @Input()
  dentalType: number;

  @Input()
  fisioType: number;

  constructor() {
    super();
  }

  ngOnInit() {
  }

}
